import { localPrefs } from "../native-modules/tare/getLocalPrefs";

export const NPS_SAVE_TRIGGER_NAMESPACE = "JobsearchFeedback";
export const NPS_SAVE_TRIGGER_KEY = "NpsSaveTriggerTimestamp";
// 30-min TTL so a stale save can't fire NPS on a much later visit.
export const SAVE_TRIGGER_TTL_MS = 30 * 60 * 1000;

export const SAVE_JOB_TOAST_DURATION_MS = 3000;

/**
 * Records a save-job NPS trigger so the Homepage can later show the survey
 * (RN-4843). Best-effort so a failed write never blocks a save.
 */
export async function recordNpsSaveTrigger(): Promise<void> {
  try {
    await localPrefs.setLong(NPS_SAVE_TRIGGER_NAMESPACE, NPS_SAVE_TRIGGER_KEY, Date.now());
  } catch {
    return;
  }
}
